export default "__VITE_ASSET__DcvJi7aN__"